import axios from 'axios';
import * as Sentry from '@sentry/vue';

const REQUEST_TIMEOUT = 60 * 60 * 1000 // 1 hour

const instance = axios.create({
    baseURL: process.env.VUE_APP_URL,
    withCredentials: true,
    timeout: REQUEST_TIMEOUT,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

const errorInterceptor = error => {

    if (!error.response) {
        console.error('Network/Server error', error)
        return Promise.reject(error)
    }

    if ((error.response.status < 400) || (error.response.status >= 500)) {
        Sentry.captureException(error)
    }

    console.error(error.response.status, error.message);
    return Promise.reject(error)
};

instance.interceptors.response.use(undefined, errorInterceptor);

export default instance;
